import { createSelector } from 'reselect';

const getCurrentUser = createSelector(
  (state) => state.user,
  (user) => user?.data,
);

export default getCurrentUser;
